import axios from "axios";
import { useState, useEffect } from "react";
import axiosInstance from "../utils/axiosInstance";
// takes two props 
// /////  1. url
// /////  2. dependency in state like const [refresh,setRefresh]=useState(false)

/// Example usage:
/// const [data, loading] = UseFetch("/users", [refresh]);
const UseFetch = (url, deps = []) => {
  const token = localStorage.getItem("token");

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true); // <-- Loading state

  const fetchList = async () => {
    setLoading(true); // Start loading
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.get(url);
      // const response = await axios.get(url, { headers });

      const list = response.data.data;
      setData(list);
    } catch (error) {
      console.error("Error connecting to API", error);
       const message = error?.response?.data?.messag;
    console.log("message: in instace", message);

    if (message === "Invalid Authentication" || error?.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login"; // Redirect to login
    }
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchList();
  }, [url, ...deps]);

  return [data, loading];
};

export default UseFetch;



// import axios from "axios";
// import { useState, useEffect } from "react";
// ///// takes two props 
// /////  1. url
// /////  2. dependency in state like const [refresh,setRefresh]=useState(false)

// /////  Example how to call
// ///// const [data]=UseFetch("/users",[refresh])
// const UseFetch = (url, deps = []) => {
//   const token = localStorage.getItem("token");

//   const [data, setData] = useState(null);
//   const fetchList = async () => {
//     try {
//       const headers = {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//         Authorization: `Bearer ${token}`,
//       };
//       const response = await axios.get(url, { headers });

//       const list = response.data.data;
//       setData(list);
//     } catch (error) {
//       console.error("Error connecting to API", error);
//     }
//   };

//   useEffect(() => {
//     fetchList();
//   }, [url, ...deps]);

//   return [data];
// };

// export default UseFetch;
